import { Formik, Form } from 'formik';
import {
    initialValues,
    validationSchema_19505,
} from 'blocks/Form/data/validation';
import FirstName from 'blocks/Form/fields/FirstName';
import LastName from 'blocks/Form/fields/LastName';
import Email from 'blocks/Form/fields/Email';
import Hospital from 'blocks/Form/fields/Hospital';
import Specialty from 'blocks/Form/fields/Specialty';
import Phone from 'blocks/Form/fields/Phone';
import Location from 'blocks/Form/fields/Location';
import MarketingRequested from 'blocks/Form/fields/MarketingRequested';
import Submit from 'blocks/Form/fields/Submit';
import Role from 'blocks/Form/fields/Role';
import Notes from 'blocks/Form/fields/Notes';
import TopicsOfInterest from 'blocks/Form/fields/TopicsOfInterest';
import InqueryType from 'blocks/Form/fields/InqueryType';

/* === TMTT - General Contact === */

const Form19505 = ({ handleSubmit, isPending, language, fields }) => {
    const {
        first_name,
        last_name,
        hospital,
        email_address,
        location,
        phone,
        inquery_type,
        role,
        specialty,
        marketing_requested,
        topics_of_interest_tmtt,
        notes,
        submit,
        validation,
    } = fields;
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => handleSubmit('marketo', values)}
            validationSchema={validationSchema_19505(validation)}
        >
            {(formik) => (
                <Form className="form form--lg">
                    <div className="grid-lg-2 row-gap-0">
                        <FirstName
                            label={first_name}
                            initialValues={initialValues}
                        />
                        <LastName
                            label={last_name}
                            initialValues={initialValues}
                        />
                        <Email
                            label={email_address}
                            initialValues={initialValues}
                        />
                        <Phone label={phone} initialValues={initialValues} />
                        <InqueryType
                            initialValues={initialValues}
                            data={inquery_type}
                        />
                        <Hospital
                            label={hospital}
                            initialValues={initialValues}
                        />
                        <Specialty
                            initialValues={initialValues}
                            data={specialty}
                        />
                        <Role initialValues={initialValues} data={role} />
                        <Location
                            data={location}
                            formik={formik}
                            initialValues={initialValues}
                        />
                    </div>
                    <Notes label={notes} initialValues={initialValues} />
                    <MarketingRequested
                        formik={formik}
                        initialValues={initialValues}
                        data={marketing_requested}
                    />
                    <TopicsOfInterest
                        formik={formik}
                        initialValues={initialValues}
                        data={topics_of_interest_tmtt}
                        checkbox
                    />
                    <Submit
                        formik={formik}
                        isPending={isPending}
                        pendingText={submit.submitting}
                        validation={submit.all_required_fields}
                    >
                        {submit.contact_now}
                    </Submit>
                </Form>
            )}
        </Formik>
    );
};

export default Form19505;
